module.exports = __webpack_public_path__ + "media/Crash.86453839.ogg";